import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
export const CollapsableSection = ({ title, header, children, label }) => {
    const { t } = useAlertUiTranslation();
    const [open, setOpen] = React.useState(true);
    const collapsibleSectionIconButtonLabel = `${open ? t('common.collapse') : t('common.expand')} ${label !== null && label !== void 0 ? label : title}`;
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: {
                display: 'flex',
                flexWrap: 'wrap',
                p: 2,
                alignItems: 'center',
                gap: 1,
                backgroundColor: themeColors.surface.secondary,
            } },
            React.createElement(IconButton, { color: 'primary', onClick: () => setOpen(!open), "aria-label": collapsibleSectionIconButtonLabel },
                React.createElement(KeyboardArrowDownIcon, { sx: {
                        transform: open ? 'rotate(180deg)' : undefined,
                        transition: 'transform 150ms ease-in-out',
                    } })),
            React.createElement(Typography, { sx: { display: 'flex' }, variant: 'subtitle2' }, title),
            React.createElement(Box, { sx: { flexGrow: 1 } }, header)),
        React.createElement(Collapse, { in: open },
            React.createElement(Box, { sx: { p: 2, pt: 0, backgroundColor: themeColors.surface.secondary } },
                React.createElement(Box, { sx: { backgroundColor: themeColors.surface.tertiary } }, children)))));
};
